<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">采购计划申请表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <consumable-plan-apply ref="create" :userData="userData" :formByFather="form"></consumable-plan-apply>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitConsumable()" class="form-btn" type="success">确认提交使用采购计划申请表
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import ConsumablePlanApply from '@/page/form/consumable/planApply'
  export default {
    components: {
      ApprovalItemByCustom,
      ConsumablePlanApply,
      ApprovalItem,
      Attachments,
    },
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          applyTime: '',
          depId: '',
          remark: '',
          type: '',
          total: '',
          items: [],
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }
    },
    mounted() {
      this.getApplyData()
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          // this.setSelectArr(this.applyInfo, 60, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/consumable/plan/info/' + this.form.applyId, '', (res) => {
          this.form = this.applyInfo = res.vo

          for (var i = 0; i < this.form.items.length; i++) {
            let _item = this.form.items[i]
            _item.consumable = {
              spec: _item.spec,
              unit: {
                name: _item.unitName
              }
            }
          }
          
          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.form.applyId = this.$route.query.applyId / 1

          this.form.depId = this.form.department.id
          this.form.json = true

          // this.setSelectArr(this.applyInfo, 60, this.form.type / 1)
          this.formLoading = false
        })
      },

      // 提交使用材料申请单
      SubmitConsumable() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/consumable/plan' : '/consumable/plan/edit?applyId=' + this.form
          .applyId

        this.form.price = util.convertCurrency(this.form.total)
        console.log(this.form)
        // return;

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交采购计划申请表成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改采购计划申请表成功，请耐心等待领导审批")
          }
          this.$router.push('/Consumable/PlanApplyList')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/consumable/PlanApply.vue